import utils from "@/shared/utils"
import { Button } from "flowbite-react"
import { useRouter } from "next/router"
import { useEffect, useState } from "react"

type props = {
    qtdCart: string,
    total: string,
    onBeforeCheckout?: () => Promise<boolean>
}

export default function CartFooterComponent({ qtdCart, total, onBeforeCheckout }: props) {
    const router = useRouter()

    const irParaCheckout = async (reservar: boolean) => {
        if (onBeforeCheckout && !reservar) {
            const ok = await onBeforeCheckout()
            if (!ok) return
        }
        router.push(reservar ? '/checkout/reserve' : '/checkout/cart')
    }

    return (
        <div key="CartFooterComponentKey" className="w-full bg-white fixed bottom-0 border-t border-gray-300 py-3 px-8 md:px-24 justify-center flex" style={{ zIndex: '48' }}>
            <div className="container grid md:grid-cols-3 items-center md:gap-14 gap-2 ">
                <div className="text-gray-600 lg:text-center lg:justify-end lg:flex lg:items-baseline md:grid hidden ">
                    <span className="text-xs">Ingressos selecionados:</span>
                    <span>
                        <strong className="lg:text-3xl text-xl text-mygreen">&nbsp;{qtdCart}</strong>
                    </span>
                </div>
                <div className="flex gap-6 justify-between md:justify-center">
                    <div className="text-gray-600 lg:text-center lg:justify-center lg:flex lg:items-baseline grid ">
                        <span className="text-xs">Total: <span className=" md:hidden"><strong>{qtdCart}</strong> {parseInt(qtdCart) > 1 ? 'ingressos' : 'ingresso'}</span></span>
                        <span>
                            <strong className="lg:text-3xl text-xl text-mygreen">{utils.currencyRegex(total, true)}</strong>
                        </span>
                    </div>
                    <Button className="hover:bg-myblue md:hidden flex mr-7 md:mr-0" size="sm" onClick={() => { irParaCheckout(false) }}>COMPRAR AGORA</Button>
                </div>
                <div className=" justify-start md:flex hidden">
                    <Button className="hover:bg-myblue" size="sm" onClick={() => { irParaCheckout(false) }}>COMPRAR AGORA</Button>
                </div>
            </div>
        </div>
    )
}